import React from 'react';
import { Link } from '../../../deps/@bshgroup/component-link';
import { breakpoints } from '../../global/global-config';
import { useTranslation } from '../../contexts/TranslationContext/TranslationContext';
import { PrimitiveType } from 'react-intl';

export interface TranslatedLinkProps {
  id: string;
  links: { [id: string]: string };
  linkAs?: any;
  openLinkInNewTab?: boolean;
  values?: { [p: string]: PrimitiveType };
}

export function TranslatedLink({ id, links, linkAs, openLinkInNewTab, values }: TranslatedLinkProps) {
  const { tm } = useTranslation();
  const LinkType = linkAs || 'a';
  const hrefLink: boolean = LinkType === 'a';

  const renderLink = (children: any, url: string) => (
    <Link
      as={LinkType}
      {...(hrefLink ? { href: url } : ({ to: url } as any))}
      css={{ fontSize: 'inherit !important' }}
      size={{
        [breakpoints.sm]: 'md',
        [breakpoints.md]: 'lg',
        [breakpoints.lg]: 'lg',
      }}
      variant="prominent"
      target={openLinkInNewTab ? '_blank' : undefined}
    >
      {children}
    </Link>
  );

  return tm(id, {
    ...values,
    ...Object.fromEntries(Object.entries(links).map(([key, url]) => [key, children => renderLink(children, url)])),
  });
}
